import { Sheet, SheetContent } from "../../components/ui/sheet";
import { GRCDashboardNew } from "../GRCDashboardNew";

interface DrillOrg {
  id: string;
  name: string;
}

/* ══════════════════════════════════════════════════════════════════════
   Side panel that drills into a single organisation.
   Reuses the existing per-org dashboard (GRCDashboardNew) locked to `org`.
   ══════════════════════════════════════════════════════════════════════ */
export function OrgDrillDownDrawer({
  org,
  open,
  onOpenChange,
}: {
  org: DrillOrg | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="flex h-full max-h-screen w-[96vw] flex-col gap-0 border-l border-border bg-background p-0 sm:max-w-[1480px]"
      >
        {/* key forces a fresh mount per org so internal state resets.
            flex-1 + min-h-0 lets this region fill the panel and scroll —
            h-full alone clips the lower sections inside the flex column. */}
        <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
          {org && <GRCDashboardNew key={org.id} embeddedOrg={org} />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
